import { useEffect, useState, useContext } from "react";
import css3 from "../Approvals/css/approval-table.module.css";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { useSettingModal } from "../../../hooks/Context";
import ViewDetails from "./ViewDetails";
import { NotificationContext } from "../../../providers/notification";

const DATA_PER_PAGE = 10;

interface UploadOffLinePaymentItem {
  PaymentHistoryId: number;
  ApplicantId: string;
  FullName: string;
  CustomerEmail: string;
  CustomerPhone: string;
  PaymentDate: string;
  Amount: number;
  RouteName: string;
  PaymentStatus: string;
  RecieptUrl: string;
}

const UploadOffLinePaymentTable = (props: { data: UploadOffLinePaymentItem[]; routeId?: number }) => {
  const [activeData, setActiveData] = useState<UploadOffLinePaymentItem[]>([]);
  const [pageData, setPageData] = useState<UploadOffLinePaymentItem[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageArr, setPageArr] = useState<number[]>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<number | null>(null);

  const { setShowModal, setModalContent } = useSettingModal();
  const { showNotification } = useContext(NotificationContext);

  const data = props.data || [];

  // Pagination setup
  useEffect(() => {
    if (data.length > 0) {
      setActiveData(data);
      const lastPage = Math.ceil(data.length / DATA_PER_PAGE);
      setPageArr(Array.from({ length: lastPage }, (_, i) => i));
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData.length > 0) {
      const start = currentPage * DATA_PER_PAGE;
      const stop = start + DATA_PER_PAGE;
      setPageData(activeData.slice(start, stop));
    }
  }, [currentPage, activeData]);

  // Handlers
  const handlePrevous = () => {
    if (pageArr.length <= 1) return setCurrentPage(0);
    if (currentPage === 0) return setCurrentPage(pageArr.at(-1) || 0);
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (pageArr.length <= 1) return setCurrentPage(0);
    if (currentPage === pageArr.at(-1)) return setCurrentPage(0);
    setCurrentPage(currentPage + 1);
  };

  const handleMore = (index: number) => {
    setShowIndex(index === showIndex ? null : index);
    setShowMore(index !== showIndex);
  };

  const handleViewDetails = (row: UploadOffLinePaymentItem) => {
    setModalContent(<ViewDetails data={row} />);
    setShowModal(true);
  };

  return (
    <div className={css3.container}>
      <>
        {/* Table header */}
        <div style={{ gridTemplateColumns: `1fr 1.2fr 1.5fr 1.2fr 1fr 1fr 0.5fr` }}>
          <div>Applicant ID</div>
          <div>Name</div>
          <div>Email</div>
          <div>Phone</div>
          <div>Amount</div>
          <div>Status</div>
          <div></div>
        </div>

        {/* Table body */}
        <div>
          {pageData.map((row, index) => (
            <div
              key={row.PaymentHistoryId}
              style={{ gridTemplateColumns: `1fr 1.2fr 1.5fr 1.2fr 1fr 1fr 0.5fr` }}
            >
              <div>{row.ApplicantId}</div>
              <div>{row.FullName || "-"}</div>
              <div>{row.CustomerEmail}</div>
              <div>{row.CustomerPhone}</div>
              <div>{row.Amount}</div>
              <div
                style={{
                  color: row.PaymentStatus === "Successful" ? "green" : "red",
                  fontWeight: 500,
                }}
              >
                {row.PaymentStatus}
              </div>
              <span
                className={`${css3.moreSpan} ${index === showIndex ? css3.activeMore : ""}`}
                onClick={() => handleMore(index)}
              >
                <MoreIcon />
                {index === showIndex && showMore && (
                  <div>
                    {/* <div onClick={() => handleViewDetails(row)}>View Details</div> */}
                    {row.RecieptUrl && (
                      <a href={row.RecieptUrl} target="_blank" rel="noreferrer">
                        View Receipt
                      </a>
                    )}
                  </div>
                )}
              </span>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className={css3.pagination}>
          <div>
            <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous}>
              <LBtn />
            </button>
            {pageArr.map((p) => (
              <span
                key={p}
                style={
                  p === currentPage
                    ? { backgroundColor: "var(--activeP-back)", color: "var(--white-color)" }
                    : {}
                }
                onClick={() => setCurrentPage(p)}
              >
                {p + 1}
              </span>
            ))}
            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}>
              <RBtn />
            </button>
          </div>
        </div>
      </>
    </div>
  );
};

export default UploadOffLinePaymentTable;
